import React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { v4 as uuidv4 } from "uuid"
import {
  ContentWrapper2,
  HorizontalScrollableSectionWrapper,
  SectionWrapper,
} from "../../building-blocks/atoms/containers/containers"
import { CardImg } from "../../building-blocks/atoms/images/images"
import {
  BannerOverlayText,
  BannerOverlaySubtext,
  ActionLinks,
  CardHeaderText2,
} from "../../building-blocks/atoms/texts/texts"
import platform1 from "../../assets/images/platform1.jpg"
import { scroll } from "../../utils/locomotiveScroll"

//console.log(uuidv4())

const LIST = [
  {
    id: uuidv4(),
    step: "1/1",
    img: platform1,
    location: "Global, 2020",
    product: "Krazyfast",
    sector: "Industry - Logistics",
    url: "/krazyfast",
  },
]

// const Wrapper = styled.div`
//   display: grid;
//   column-gap: 12%;
//   grid-template-columns: 1fr 1fr;

//   div:nth-of-type(even) {
//     margin-top: 15rem;
//     margin-bottom: 9rem;
//     float: right;
//   }
// `
const TitleBg = styled.div`
  background: var(--color-sec);
  color:var(--color-sec);
  position: absolute;
  top: 30%;
  left: 15.4%;
  z-index: -1;
  width: 5%;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    display: none;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    display: none;
  }
  @media ${({ theme }) => theme.mediaQueries.tablet_landscape}{
    top: 155px;
    left: 160px;
  }
  @media ${({ theme }) => theme.mediaQueries.ipad_pro}{
    top: 25%;
    left: 16%;
    width: 8%;
  }

`



function PlatformContext() {
  React.useEffect(() => {
    scroll()
  }, [])


  const [isMobile, setisMobile] = React.useState(null)

const changeMobile = () => {
  window.matchMedia("(max-width: 37.5em)").matches
    ? setisMobile(true)
    : setisMobile(false)
}

React.useEffect(() => {
  window.scroll(0, 0)
  scroll()
  changeMobile()
  window.addEventListener("resize", changeMobile)
  return () => window.removeEventListener("resize", changeMobile)
}, [])

  return (
    <>
      <SectionWrapper
        style={{ height:isMobile ? "60vh" :  "100vh", zIndex: 2, position: "relative" }}
        data-scroll-section
      >
        <InsideSectionWrapper
          style={{
            alignItems: "flex-start",
            justifyContent: "flex-start",
            position: "absolute",
          }}
        >
          <BannerOverlaySubtext style={{ padding: "0% 3%" }}>
            Platform
          </BannerOverlaySubtext>
          <TitleBg>ugihihihi</TitleBg>
          <>
         
            <BannerOverlayText style={{width: isMobile ? "100%" : "75"}}
              
              data-scroll
              data-scroll-speed="-2"
            >
              Providing extension <br /> and ease to deliver best <br /> results
            </BannerOverlayText>
          </>
        </InsideSectionWrapper>
      </SectionWrapper>

      <SectionWrapper style={{ height: "100vh" }} data-scroll-section>
        <HorizontalScrollableSectionWrapper
          style={{
            height: "68vh",
            columnGap: "18%",
            paddingLeft: "9%",
          }}
        >
          {isMobile ? (
            <div style={{color:"#fff",padding:"0px",marginTop:"20px"}}>{LIST.map((i)=>(
              <MobileWrapper to={i.url}  key={i.id} >
             
               <MobileImgWrapper src={i.img} />     
               <CardNumberTextBackground style={{position : 'absolute', height:"50px", width:"50px", top : '-25px', left : '145px', zIndex :"6"}}>{i.step}</CardNumberTextBackground>
               <MobileProductWrapper >{i.product}</MobileProductWrapper>
              
             <MobileSectionWrapper >
            
              <p>{i.location}</p>
              <p>{i.sector}</p>
               </MobileSectionWrapper>
              
              </MobileWrapper>
            ))}
            </div>
          ):(
            <>
            {LIST.map((i) => (
            <ContentWrapper2 key={i.id} to={i.url}>
              <CardImageWrapper>
                <CardImg
                  style={{ height: "auto", opacity: "0.65" }}
                  src={i.img}
                  alt=""
                />
              </CardImageWrapper>
              <ContextWrapper>
                <CardNumberTextBackground>{i.step}</CardNumberTextBackground>

                <CardContent>
                  <ActionLinks>{i.sector}</ActionLinks>
                  <CardHeaderText2 style={{ marginBottom: "3rem" }}>
                    {i.product}
                  </CardHeaderText2>
                  <ActionLinks>{i.location}</ActionLinks>
                </CardContent>
              </ContextWrapper>
            </ContentWrapper2>
          ))}
            </>
          )}

          
        </HorizontalScrollableSectionWrapper>
      </SectionWrapper>
    </>
  )
}

export default PlatformContext

const ContextWrapper = styled.div`
  position: relative;
  z-index: 2;
  top: -95%;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
`

const CardNumberTextBackground = styled.p`
  color: black;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  -webkit-letter-spacing: 0.1rem;
  -moz-letter-spacing: 0.1rem;
  -ms-letter-spacing: 0.1rem;
  letter-spacing: 0.1rem;
  margin: 0rem;
  background: var(--color-pri);
  padding: 0.5rem;
  margin-left: -1.5rem;
`

const CardContent = styled.div`
  position: relative;
  right: -66%;
  top: 58%;
  width: 42vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  word-break: break-word;
`

export const CardImageWrapper = styled.div`
  width: 100%;
  height: 68vh;
  min-width: fit-content;
  background: var(--color-blk);
  margin-top: 2%;
`
const MobileWrapper = styled(Link)`
  text-decoration: none !important;
  color: #fff;
  font-family: raphic;
  position : relative;
  padding-bottom : 50px;
  display : flex;
  justify-content : center;
  align-items : center;
  flex-direction : column;


`

const MobileImgWrapper = styled.img`
height:300px;
 width:300px;
 margin-left:70px;
`
const MobileProductWrapper = styled.p`
position : absolute;
top: 200px;
left : 100px;
z-index : 10;
color : white;
font-size : 35px;
font-weight:900;

`
const MobileSectionWrapper = styled.div`
textAlign : left;
width :50%;
padding-top : 12px;
fontSize: 0.9rem;
fontWeight: bold;

`
const InsideSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: 15% 18% 0% 15%;
  @media ${({ theme }) => theme.mediaQueries.mobile}{
    padding: 48% 0% 0% 8%;

  }
`